module.exports = __webpack_public_path__ + "static/media/banner-footer.f29f282a.png";